<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="toNewRouter('invoice-over-view')" >-->
        <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
        <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="2" @click="toNewRouter('patrol-point-manage')" v-if="permissionCodes.indexOf('025001000') !== -1">
        <i class="el-icon-damai-xungeng" style="font-size: 24px;"></i>
        <span slot="title">巡更点管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('team-manage')" v-if="permissionCodes.indexOf('025002000') !== -1">
        <i class="el-icon-damai-banzu" ></i>
        <span slot="title">班组管理</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('patrol-route-manage')" v-if="permissionCodes.indexOf('025003000') !== -1">
        <i class="el-icon-damai-xungengluxianguanli"></i>
        <span slot="title">巡更路线</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('workforce-manage')" v-if="permissionCodes.indexOf('025004000') !== -1">
        <i class="el-icon-damai-paiban"></i>
        <span slot="title">排班管理</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('patrol-task')" v-if="permissionCodes.indexOf('025007000') !== -1">
        <i class="el-icon-damai-ic_xungengrenwu"></i>
        <span slot="title">巡更任务</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('patrol-report')" v-if="permissionCodes.indexOf('025008000') !== -1">
        <i class="el-icon-damai-ic_xungengbaobiao"></i>
        <span slot="title">巡更报表</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('keep-watch-record')" v-if="permissionCodes.indexOf('025005000') !== -1">
        <i class="el-icon-damai-xungengxitong_xungengjilu" style="font-size: 20px;"></i>
        <span slot="title">巡更记录</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('keep-watch-log')"  v-if="permissionCodes.indexOf('025006000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "keep-watch-over-view",
  2: ["patrol-point-manage", "patrol-point-add", "patrol-point-modify"],
  3: ["team-manage", "team-add", "team-modify"],
  4: ["patrol-route-manage", "patrol-route-add", "patrol-route-modify"],
  5: ["workforce-manage", "workforce-add", "workforce-modify"],
  6: ["keep-watch-record"],
  7: ["keep-watch-log"],
  8: ["patrol-task"],
  9: ["patrol-report"]
});

export default {
  name: "keep-watch-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/KeepWatch/KeepWatchNav.vue